import React from 'react';
import classes from "./Layout.module.css";
import { Navbar } from "../major-components/Navbar";
import { useEffect, useState } from "react";
import { axiosInstance } from "../../constants/axiosInstance";
import { HeroMapInput } from "../minor-components/HeroMapInput";
import { useLocation } from "react-router";
import instagramImage from '../../assets/icons/instagram_logo.gif';
import twitterImage from '../../assets/icons/twitter_logo.gif';
import telegramImage from '../../assets/icons/telegram_logo.gif';
import { getSocialLinks } from "../../redux/Actions/SocialLinksAction";
import { useDispatch, useSelector } from "react-redux";
import { Agevalidation } from "../major-components/AgeConformation";
import  UserNotifications  from "../major-components/UserNotifications";
import io from 'socket.io-client';

function Layout(props) {

    const dispatch = useDispatch();
    const params = useLocation();
    const [isAuth, setIsAuth] = useState(true);
    const [isVerified, setIsVerified]=useState('no')
    const [socket, setSocket] = useState(null);
    const [currentUserId, setCurrentUserId] = useState(null);
    const [editHeaderPreview, seteditHeaderFilePreview] = useState('')

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user && user._id) {
            setCurrentUserId(user._id);
        }
    
        const initializeSocket = () => {
            try {
                const BACKEND_URL = process.env.NODE_ENV === 'production'
                    ? 'https://api.codebreakers.online'  // Changed this line
                    : 'http://localhost:8080';
        
                const newSocket = io(BACKEND_URL, {
                    withCredentials: true,
                    transports: ['websocket', 'polling'],
                    path: '/socket.io',
                    reconnectionAttempts: 5,
                    reconnectionDelay: 1000,
                    timeout: 45000,
                    autoConnect: true,
                    forceNew: true,
                    extraHeaders: {
                        'Origin': process.env.NODE_ENV === 'production' 
                            ? 'https://codebreakers.online'
                            : 'http://localhost:3000'
                    },
                    cors: {
                        origin: process.env.NODE_ENV === 'production' 
                            ? 'https://codebreakers.online'
                            : 'http://localhost:3000',
                        credentials: true
                    }
                });
        
                newSocket.on('connect', () => {
                    console.log('Connected to socket server:', newSocket.id);
                    if (currentUserId) {
                        newSocket.emit('join', currentUserId);
                    }
                });
        
                newSocket.on('connect_error', (error) => {
                    console.error('Socket connection error details:', {
                        message: error.message,
                        description: error.description,
                        context: error.context
                    });
                    // Implement exponential backoff
                    const backoffDelay = Math.min(1000 * Math.pow(2, newSocket.reconnectionAttempts), 10000);
                    setTimeout(initializeSocket, backoffDelay);
                });
        
                return () => {
                    if (newSocket) {
                        newSocket.disconnect();
                    }
                };
            } catch (error) {
                console.error('Socket initialization error:', error);
                setTimeout(initializeSocket, 5000);
            }
        };
    
        initializeSocket();
    }, [currentUserId]);


    useEffect(() => {
        getHeaderImages();
    }, [])
    


    const { socialLink } = useSelector(
        (state) => state.socialReducer
    )

    useEffect(() => {
        dispatch(getSocialLinks())
    }, [])

    useEffect(() => {
        const excludedRoutes = ['/sign-up', '/login', '/reset-password', 'accounts', '/confirm-password'];
        const isExcludedRoute = excludedRoutes.some((route) => params.pathname.startsWith(route));

        setIsAuth(!isExcludedRoute);
    }, [params.pathname]);
     
    const getHeaderImages = async () => {
        await axiosInstance.get('/api/v1/headerimages/getHeaderImages')
            .then((res) => {
              //  console.log(res.data.data, 'Images Get')
                let images = res.data.data;
                if (images.length !== 0) {
                    seteditHeaderFilePreview(res.data.data[0].headerPhotos)
                }

            })
            .catch((err) => {

            })
    }

    return (
        <div>
            {
                !localStorage.getItem('verified') && isVerified === 'no' && (
                    <Agevalidation isVerified={isVerified} setIsVerified={setIsVerified} />
                )
            }
            {isAuth ? (
                <>
                    <Navbar 
                        userGeomery={props.userGeomery} 
                        setUserGeomery={props.setUserGeomery} 
                        searchQuery={props.searchQuery} 
                        setSearchQuery={props.setSearchQuery} 
                        location={props.location} 
                        setLocation={props.setLocation}
                        notificationComponent={currentUserId && socket ? 
                            <UserNotifications socket={socket} userId={currentUserId} /> 
                            : null
                        }
                    />
                         <HeroMapInput headerImage={editHeaderPreview} />
                </>
            ) : null}


            <main className={classes.main}>
                {React.Children.map(props.children, child => {
                    return React.cloneElement(child, {
                        searchQuery: props.searchQuery,
                        setSearchQuery: props.setSearchQuery
                    });
                })}
            </main>
            <div className="floating-container">
                <div className="floating-button">+</div>
                {Object.keys(socialLink).length > 0 && (
                    <div className="element-container">
                        {socialLink.instagram && (
                            <span className="float-element tooltip-left">
                                <a className="trans" href={socialLink.instagram} target="_blank">
                                    <img src={instagramImage} alt="Instagram" />
                                </a>
                            </span>
                        )}
                        {socialLink.twitter && (
                            <span className="float-element">
                                <a className="trans" href={socialLink.twitter} target="_blank">
                                    <img src={twitterImage} alt="Twitter" />
                                </a>
                            </span>
                        )}
                        {socialLink.telegram && (
                            <span className="float-element">
                                <a className="trans" href={socialLink.telegram} target="_blank">
                                    <img src={telegramImage} alt="Telegram" />
                                </a>
                            </span>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Layout;